class OrderValidationError extends Error {
    constructor(message) {
        super(message);
        this.clientMessages = [];

        /**
         * If this error relates to certain cart lines attach them here.
         *
         * @type {CartLine[]}
         */
        this.cartLines = [];
    }

    setCartLines(lines) {
        this.cartLines = lines;
        return this;
    }

    setClientMessages(arr) {
        this.clientMessages = arr;
        return this;
    }
}

OrderValidationError.ADDITIONAL_CUSTOM_FIELDS_NOT_PRESENTED = 'ADDITIONAL_CUSTOM_FIELDS_NOT_PRESENTED';
OrderValidationError.ADJUSTMENT_VALIDATION_FAILED = 'ADJUSTMENT_VALIDATION_FAILED';
OrderValidationError.CART_EMPTY = 'CART_EMPTY';
OrderValidationError.CUSTOMER_ACCOUNT_REQUIRED = 'CUSTOMER_ACCOUNT_REQUIRED';
OrderValidationError.DELIVERY_ADDRESS_REQUIRED = 'DELIVERY_ADDRESS_REQUIRED';
OrderValidationError.DEVICE_OFFLINE = 'DEVICE_OFFLINE';
OrderValidationError.DUPLICATE_MEMBER_REFS = 'DUPLICATE_MEMBER_REFS';
OrderValidationError.DUPLICATE_MEMBERSHIP_REFS = 'DUPLICATE_MEMBERSHIP_REFS';
OrderValidationError.DUPLICATE_STAFF_REF = 'DUPLICATE_STAFF_REF';
OrderValidationError.FIELD_DATA_INVALID = 'FIELD_DATA_INVALID';
OrderValidationError.GIFT_AID_CUSTOMER_INFO_REQUIRED = 'GIFT_AID_CUSTOMER_INFO_REQUIRED';
OrderValidationError.GIFT_AID_UNANSWERED = 'GIFT_AID_UNANSWERED';
OrderValidationError.POSITIVE_VALUE_ADJUSTMENT_FORBIDDEN = 'POSITIVE_VALUE_ADJUSTMENT_FORBIDDEN';
OrderValidationError.MISSING_MEMBERSHIP_DATA = 'MISSING_MEMBERSHIP_DATA';
OrderValidationError.MISSING_TRADING_SESSION_ID = 'MISSING_TRADING_SESSION_ID';
OrderValidationError.NEGATIVE_VALUE_ADJUSTMENT_FORBIDDEN = 'NEGATIVE_VALUE_ADJUSTMENT_FORBIDDEN';
OrderValidationError.ORDER_EDIT_REFUND_DETAILS_NOT_ENTERED = 'ORDER_EDIT_REFUND_DETAILS_NOT_ENTERED';
OrderValidationError.STAFF_REF_REQUIRED = 'STAFF_REF_REQUIRED';
OrderValidationError.STOCK_LEVEL_ERROR = 'STOCK_LEVEL_ERROR';

module.exports = OrderValidationError;
